import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../constants';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
    },
    button: {
        color: theme.palette.primary.main,
        height: '4.5rem',
        width: '100%',
        borderRadius: '5px',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: grey[200],
            border: `1px solid ${theme.palette.error.main}`,
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 0,
        textTransform: 'none',
        fontSize: '1.6rem',
    },
    iconContainer: {
        height: '100%',
        width: '4.5rem',
        fontSize: '2.5rem',
        padding: theme.spacing(1),
        marginRight: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    googleIcon: {
        width: '2.4rem',
        height: '2.4rem',
    },
    errorText: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
        fontSize: '1rem',
    },
}));

// Google icon SVG component
const GoogleIcon = () => (
    <svg className="googleIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
);

export default function GoogleLogin({ userType }) {
    const classes = useStyles();
    const [error, setError] = useState(null);

    useEffect(() => {
        setError(null);
    }, [userType]);

    const handleClick = (userType) => {
        if (userType) {
            window.open(`${API_BASE_URL}/auth/google?userType=${userType}`);
        } else {
            setError('アカウントタイプを選択してください');
        }
    };

    return (
        <Box className={classes.root}>
            <Button
                className={classes.button}
                onClick={() => handleClick(userType)}
                variant="outlined"
                fullWidth
            >
                <Box className={classes.iconContainer}>
                    <GoogleIcon />
                </Box>
                Google アカウントでログイン
            </Button>
            {error && (
                <Typography className={classes.errorText}>
                    {error}
                </Typography>
            )}
        </Box>
    );
}
